import { Box, IconButton } from "@mui/material";
import useFilterOption from "../../hooks/useFilterOption.js";
import {
  inspStatusFilterState,
  tempFilterOptionState,
} from "../../recoil/index.ts";
import { useEffect, useState } from "react";
import { getInspectRules } from "../../services/inspectService.js";
import "../../styles/searchStyle.css";
import { CachedIcon } from "../../icons/index.tsx";
import { useLocation } from "react-router-dom";
import { useRecoilState, useResetRecoilState } from "recoil";

export const InspStatusFilter = ({ clientIps, lotList }) => {
  const [firstFilterOption, setFilterOption] = useState(false);
  const { filterOption, handleFilterChange, handleRangeChange } =
    useFilterOption(inspStatusFilterState);
  const [tempFilterOption, setTempFilterOption] = useRecoilState(
    tempFilterOptionState
  );
  const today = new Date().toISOString().split("T")[0];
  const [dateRange, setDateRange] = useState({
    start: filterOption.start_date,
    end: filterOption.end_date,
  });
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState(filterOption.material || "");
  const [allRules, setAllRules] = useState([]);
  // const [clientIps, setClientIps] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const fetchInspRules = async () => {
      try {
        const response = await getInspectRules();
        const rules = response.data;
        setAllRules(rules);
      } catch (error) {
        console.error("Error fetching inspection rules:", error);
      }
    };
    fetchInspRules();
  }, []);

  const handleDateChange = (key) => (event) => {
    const newValue = event.target.value;
    setDateRange((prev) => ({
      ...prev,
      [key]: newValue,
    }));
  };

  const handleResetDate = () => {
    setDateRange({
      start: "",
      end: "",
    });
  };

  useEffect(() => {
    handleRangeChange(
      "start_date",
      "end_date"
    )({
      target: {
        value: [dateRange.start, dateRange.end],
      },
    });
  }, [dateRange]);

  // const handleInputChange = async (e) => {
  //   const value = e.target.value;
  //   setInputValue(value);

  //   if (value.length > 0) {
  //     const filtered = allRules.filter((item) =>
  //       item.toLowerCase().includes(value.toLowerCase())
  //     );
  //     setSuggestions(filtered);
  //   } else {
  //     setSuggestions([]);
  //   }
  // };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value.length > 0) {
      const filtered = allRules.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered);
    } else {
      setSuggestions([]);
    }
  };

  const commitInputValue = () => {
    if (inputValue.trim() === "") return;

    setTempFilterOption((prev) => ({
      ...prev,
      material: inputValue, // allRules에 없어도 그냥 그대로 저장
    }));
    setSuggestions([]);
  };

  return (
    <>
      <div className="search-container">
        <span>Search by Name</span>
        <input
          type="text"
          id="search-text-field"
          placeholder="이름을 입력하세요"
          value={filterOption.name || ""}
          onChange={handleFilterChange("name")}
          style={{ border: "solid 1px gray" }}
        />
      </div>
      <div className="search-container" style={{ position: "relative" }}>
        <span>Material</span>
        {/* <input
          type="text"
          id="search-text-field"
          placeholder="내용을 입력 후 선택하세요"
          value={inputValue}
          onChange={handleInputChange}
          // onChange={handleFilterChange("material")}
          style={{ width: "100%", boxSizing: "border-box" }}
        /> */}
        <input
          type="text"
          id="search-text-field"
          placeholder="내용을 입력 후 선택하세요"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={commitInputValue} // 포커스 잃으면 값 확정
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              commitInputValue(); // 엔터 치면 값 확정
            }
          }}
          style={{
            width: "100%",
            boxSizing: "border-box",
            border: "solid 1px gray",
          }}
        />
        {suggestions.length > 0 && (
          <ul
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              width: "100%",
              backgroundColor: "#fff",
              border: "1px solid #ccc",
              listStyle: "none",
              margin: 0,
              padding: "0.5rem",
              zIndex: 1000,
              maxHeight: "200px",
              overflowY: "auto",
            }}
          >
            {suggestions.map((item, idx) => (
              <Box
                key={idx}
                component="li"
                onClick={() => {
                  setInputValue(item);
                  setSuggestions([]);
                  // handleFilterChange("material")(item);
                  setTempFilterOption((prev) => ({
                    ...prev,
                    ["material"]: item,
                  }));
                  // setFilterOption((prev) => ({ ...prev, material: item }));
                }}
                sx={{
                  cursor: "pointer",
                  padding: "0.25rem 0",
                  "&:hover": { backgroundColor: "#f1f1f1ff" },
                }}
              >
                {item}
              </Box>
            ))}
          </ul>
        )}
      </div>
      {location.pathname.includes("/report") ? (
        <div className="filter-option">
          <span>Client IP</span>
          <select
            value={filterOption.client_ip || ""}
            onChange={handleFilterChange("client_ip")}
          >
            {clientIps.map((ip, index) => (
              <option key={index} value={ip.client_ip}>
                {ip.client_ip}
              </option>
            ))}
          </select>
        </div>
      ) : (
        <div className="search-container">
          <span>Client</span>
          <input
            type="text"
            id="search-text-field"
            placeholder="내용을 입력하세요"
            value={filterOption.client_ip || ""}
            onChange={handleFilterChange("client_ip")}
            style={{ border: "solid 1px gray" }}
          />
        </div>
      )}
      {location.pathname.includes("/report") ? (
        <div className="filter-option">
          <span>Lot</span>
          <select
            value={filterOption.lot || ""}
            onChange={handleFilterChange("lot")}
          >
            <option value="">전체</option>
            {lotList.map((lot, index) => (
              <option key={index} value={lot.lot}>
                {lot.lot}
              </option>
            ))}
          </select>
        </div>
      ) : (
        <div className="search-container">
          <span>Lot</span>
          <input
            type="text"
            id="search-text-field"
            placeholder="내용을 입력하세요"
            value={filterOption.lot || ""}
            onChange={handleFilterChange("lot")}
            style={{ border: "solid 1px gray" }}
          />
        </div>
      )}
      <div className="date-option">
        <span>Label</span>
        <input
          type="text"
          id="search-text-field"
          placeholder="내용을 입력하세요"
          value={filterOption.label || ""}
          onChange={handleFilterChange("label")}
          style={{ border: "solid 1px gray" }}
        />
      </div>
      <div className="search-container">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "fit-content",
          }}
        >
          <span>Date Range</span>
          <IconButton onClick={handleResetDate}>
            <CachedIcon sx={{ fontSize: "18px" }} />
          </IconButton>
        </div>
        <div>
          <input
            type="date"
            style={{
              width: "125px",
              height: "30px",
              border: "1px solid gray",
              backgroundColor: "var(--bg-color)",
              padding: "8px",
              borderRadius: "4px",
            }}
            max={today}
            value={dateRange.start}
            onChange={handleDateChange("start")}
          />
          {" ~ "}
          <input
            type="date"
            style={{
              width: "125px",
              height: "30px",
              border: "1px solid gray",
              backgroundColor: "var(--bg-color)",
              padding: "8px",
              borderRadius: "4px",
            }}
            max={today}
            value={dateRange.end}
            onChange={handleDateChange("end")}
          />
        </div>
      </div>
    </>
  );
};
